import { gql } from '@apollo/client';

export const discussionBasicFragment = gql`
  fragment discussionBasicFragment on Discussion {
    id
    title
    description
    status
    textStatus
    textCustomTimeFrameEnabled
    textStartDate
    textEndDate
    timeFrames {
      id
      startDateTime
      endDateTime
    }
    type
  }
`;

export const discussionListFragment = gql`
  ${discussionBasicFragment}
  fragment discussionListFragment on Discussion {
    ...discussionBasicFragment
    hasVisited
    isRecommended
    participationHistory {
      id
      attendeeId
      firstName
      lastName
      title
      company
      profilePicture
    }
    participationHistoryCount
  }
`;

export const discussionDetailsFragment = gql`
  ${discussionBasicFragment}
  fragment discussionDetailsFragment on Discussion {
    ...discussionBasicFragment
    chatSettings {
      isEnabled
      stream {
        channelId
        channelType
        isAvailable
      }
      timeRange {
        startDate
        endDate
      }
    }
  }
`;

export const participantFragment = gql`
  fragment participantFragment on Participant {
    id
    attendeeId
    firstName
    lastName
    title
    company
    profilePicture
  }
`;

export const roomFragment = gql`
  ${participantFragment}
  fragment roomFragment on Room {
    id
    startDate
    active
    updatedAt
    participants {
      ...participantFragment
    }
  }
`;

export const GET_ROOMS = gql`
  ${roomFragment}
  query GET_ROOMS($eventId: String!, $type: IdType = EVENT, $roomIds: RoomListInput) {
    getAttendeeRooms(contextInput: { entityId: $eventId, type: $type }, input: $roomIds) {
      ...roomFragment
    }
  }
`;

export const GET_SAME_DISCUSSION_PARTICIPANTS = gql`
  query GET_SAME_DISCUSSION_PARTICIPANTS($eventId: String!, $type: IdType = EVENT, $discussionId: ID!) {
    getSameDiscussionParticipants(
      contextInput: { entityId: $eventId, type: $type }
      input: { discussionId: $discussionId }
    ) {
      id
    }
  }
`;
